import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * cn — combine className inputs and merge Tailwind classes.
 * Pattern adopted from shadcn/ui scaffolding.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
